module.exports = __webpack_public_path__ + "img/Call center-amico.6ba5e685.svg";